
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    /* featured-collection carousels: page by visible count */
    document.querySelectorAll('.collection-slider-row').forEach(function(row){
      var slider = row.querySelector('.slider'); if(!slider) return;
      ['prev','next'].forEach(function(name){
        var btn = row.querySelector('button[name="'+name+'"]'); if(!btn) return;
        btn.addEventListener('click', function(e){
          e.stopImmediatePropagation(); e.preventDefault();
          var item = slider.querySelector('.slider__item');
          var w = item ? item.getBoundingClientRect().width + 14 : slider.clientWidth;
          var per = window.innerWidth < 768 ? 2 : 4;
          slider.scrollBy({left: (name==='next'?1:-1) * w * per, behavior:'smooth'});
        }, true);
      });
    });
    /* tag-us strips: arrows with loop, one item per click */
    document.querySelectorAll('.shopify-section[id$="__insta"]').forEach(function(sec){
      var slider = sec.querySelector('.slider'); if(!slider) return;
      if (sec.querySelector('.almond-strip-nav')) return;
      var wrap = slider.parentElement;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      [['prev','M15 5l-7 7 7 7'],['next','M9 5l7 7-7 7']].forEach(function(cfg){
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'almond-strip-nav almond-strip-nav--' + cfg[0];
        b.setAttribute('aria-label', cfg[0] === 'prev' ? 'Precedente' : 'Successivo');
        b.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.6" stroke-linecap="square"><path d="' + cfg[1] + '"/></svg>';
        b.addEventListener('click', function(){
          var item = slider.querySelector('.slider__item'); if(!item) return;
          var grid = slider.querySelector('.slider__grid');
          var gapPx = grid ? parseFloat(getComputedStyle(grid).columnGap) || 13 : 13;
          var step = item.getBoundingClientRect().width + gapPx;
          var max = slider.scrollWidth - slider.clientWidth;
          if (cfg[0] === 'next') {
            if (slider.scrollLeft >= max - 4) { slider.scrollTo({left: 0, behavior: 'smooth'}); }
            else { slider.scrollBy({left: step, behavior: 'smooth'}); }
          } else {
            if (slider.scrollLeft <= 4) { slider.scrollTo({left: max, behavior: 'smooth'}); }
            else { slider.scrollBy({left: -step, behavior: 'smooth'}); }
          }
        });
        wrap.appendChild(b);
      });
    });
    /* rating click: smooth scroll to reviews */
    document.querySelectorAll('.almond-rating').forEach(function(r){
      r.addEventListener('click', function(){
        var sec = document.querySelector('[id$="__reviews"]');
        if (sec) sec.scrollIntoView({behavior: 'smooth', block: 'start'});
      });
    });
    /* collection filters: collapse all groups by default (almond style) */
    document.querySelectorAll('.filters .filter-group__heading').forEach(function(h){
      var targetSel = h.getAttribute('data-toggle-target');
      if (!targetSel) return;
      var t = document.querySelector(targetSel);
      if (t && t.offsetParent !== null) { h.click(); }
    });
  });
})();

(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    var pag = document.querySelector('.pagination');
    if (!pag || pag.querySelector('.almond-pag-track')) return;
    var cells = [].slice.call(pag.querySelectorAll('.pagination__number, .pagination__next')).filter(function(c){ return c.textContent.trim() !== '…' || c.querySelector('a'); });
    cells = cells.filter(function(c){ return c.offsetParent !== null; });
    if (!cells.length) return;
    var pr = pag.getBoundingClientRect();
    var first = cells[0].getBoundingClientRect();
    var last = cells[cells.length-1].getBoundingClientRect();
    var left = first.left - pr.left;
    var width = last.right - first.left;
    var track = document.createElement('div');
    track.className = 'almond-pag-track';
    track.style.left = Math.round(left) + 'px';
    track.style.width = Math.round(width) + 'px';
    pag.appendChild(track);
    var current = pag.querySelector('.underline--not-link');
    var idx = 0;
    for (var i = 0; i < cells.length; i++) { if (cells[i] === current || cells[i].contains(current) || (current && current.contains(cells[i]))) { idx = i; break; } }
    var seg = width / cells.length;
    var bar = document.createElement('div');
    bar.className = 'almond-pag-bar';
    bar.style.left = Math.round(left + idx * seg) + 'px';
    bar.style.width = Math.round(seg) + 'px';
    pag.appendChild(bar);
  });
})();

/* upsell horizontal scroller: progress-bar met pijltjes (mobiel) */
(function(){
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }
  ready(function(){
    document.querySelectorAll('.almond-upsell__grid').forEach(function(grid){
      var wrap = grid.parentElement;
      if (wrap.querySelector('.almond-upsell-progress')) return;
      var prog = document.createElement('div');
      prog.className = 'almond-upsell-progress';
      var prev = document.createElement('button');
      prev.type = 'button'; prev.className = 'almond-upsell-arrow almond-upsell-arrow--prev'; prev.setAttribute('aria-label','Precedente');
      prev.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.8" stroke-linecap="square"><path d="M15 5l-7 7 7 7"/></svg>';
      var track = document.createElement('div'); track.className = 'almond-upsell-track';
      var thumb = document.createElement('div'); thumb.className = 'almond-upsell-thumb'; track.appendChild(thumb);
      var next = document.createElement('button');
      next.type = 'button'; next.className = 'almond-upsell-arrow almond-upsell-arrow--next'; next.setAttribute('aria-label','Successivo');
      next.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#1c1c1c" stroke-width="1.8" stroke-linecap="square"><path d="M9 5l7 7-7 7"/></svg>';
      prog.appendChild(prev); prog.appendChild(track); prog.appendChild(next);
      wrap.insertBefore(prog, grid.nextSibling);
      function update(){
        var max = grid.scrollWidth - grid.clientWidth;
        var tw = track.clientWidth;
        var ratio = grid.scrollWidth > 0 ? grid.clientWidth / grid.scrollWidth : 1;
        var thumbW = Math.max(28, Math.round(ratio * tw));
        thumb.style.width = thumbW + 'px';
        var p = max > 0 ? grid.scrollLeft / max : 0;
        thumb.style.left = Math.round(p * (tw - thumbW)) + 'px';
      }
      function step(dir){
        var item = grid.querySelector('.almond-upsell__item');
        var w = item ? item.getBoundingClientRect().width + 8 : 200;
        grid.scrollBy({left: dir * w, behavior: 'smooth'});
      }
      grid.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      prev.addEventListener('click', function(){ step(-1); });
      next.addEventListener('click', function(){ step(1); });
      setTimeout(update, 120); update();
    });
  });
})();

/* ===== Card quick-add (cart-bag OR plus icon = design only):
        product with options -> size-picker bottom-sheet, otherwise instant add.
        After adding, the cart drawer opens automatically. ===== */
(function(){
  var routes = (window.theme && window.theme.routes) || {};
  var ADD_URL = routes.cartAdd || '/cart/add.js';
  var ADD_LABEL = 'Aggiungi al carrello';

  function sectionEls(){
    return ['page-header','cart-drawer']
      .map(function(s){ return document.querySelector(s); })
      .filter(function(el){ return el && el.dataset && el.dataset.sectionId; });
  }

  function openCart(){
    var d = document.querySelector('.js-cart-drawer');
    if (d && typeof d.open === 'function') d.open();
  }

  function addVariant(variantId){
    var els = sectionEls();
    var ids = els.map(function(e){ return e.dataset.sectionId; });
    var body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (ids.length){ body.append('sections', ids.join(',')); body.append('sections_url', window.location.pathname); }
    return fetch(ADD_URL, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
    .then(function(r){ return r.json().then(function(d){ return { ok: r.ok, data: d }; }); })
    .then(function(res){
      if (!res.ok) throw new Error('cart add failed');
      var data = res.data;
      if (data.sections && els.length && els.length === Object.keys(data.sections).length){
        els.forEach(function(e){ if (typeof e.updateFromCartChange === 'function') e.updateFromCartChange(data.sections[e.dataset.sectionId]); });
      } else {
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
      }
      document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { variantId: data.variant_id } }));
      return data;
    });
  }

  /* ---- instant add (products without options) ---- */
  function instantAdd(btn){
    if (btn.classList.contains('is-loading')) return;
    var vid = btn.getAttribute('data-variant-id');
    if (!vid) return;
    btn.classList.remove('is-success','is-error');
    btn.classList.add('is-loading');
    addVariant(vid).then(function(){
      btn.classList.remove('is-loading'); btn.classList.add('is-success');
      openCart();
      setTimeout(function(){ btn.classList.remove('is-success'); }, 1500);
    }).catch(function(e){
      console.log(e); // eslint-disable-line
      btn.classList.remove('is-loading'); btn.classList.add('is-error');
      setTimeout(function(){ btn.classList.remove('is-error'); }, 1500);
    });
  }

  /* ---- bottom-sheet size picker (bag mode, multi-variant products) ---- */
  var sheet, sheetBody, cache = {}, state = null;

  function buildSheet(){
    if (sheet) return;
    sheet = document.createElement('div');
    sheet.className = 'pb-qb';
    sheet.innerHTML =
      '<div class="pb-qb__backdrop"></div>' +
      '<div class="pb-qb__panel" role="dialog" aria-modal="true" aria-label="Scegli le opzioni">' +
        '<button type="button" class="pb-qb__close" aria-label="Chiudi">' +
          '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
        '</button>' +
        '<div class="pb-qb__body"></div>' +
      '</div>';
    document.body.appendChild(sheet);
    sheetBody = sheet.querySelector('.pb-qb__body');
    sheet.querySelector('.pb-qb__backdrop').addEventListener('click', closeSheet);
    sheet.querySelector('.pb-qb__close').addEventListener('click', closeSheet);
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && sheet.classList.contains('is-open')) closeSheet(); });
    // delegated handlers inside the sheet
    sheetBody.addEventListener('click', function(e){
      var opt = e.target.closest('.pb-qb__opt');
      if (opt && !opt.disabled){ selectOption(parseInt(opt.getAttribute('data-oi'),10), opt.getAttribute('data-val')); return; }
      var add = e.target.closest('.pb-qb__add');
      if (add && !add.disabled){ doSheetAdd(add); }
    });
  }

  function openShow(){
    buildSheet();
    // force reflow so the slide-up transition runs
    sheet.classList.add('is-prep');
    // eslint-disable-next-line no-unused-expressions
    sheet.offsetHeight;
    sheet.classList.add('is-open');
    sheet.classList.remove('is-prep');
    document.documentElement.classList.add('pb-qb-lock');
  }

  function closeSheet(){
    if (!sheet) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('pb-qb-lock');
  }

  function openSheet(card, handle){
    buildSheet();
    var title = '';
    var t = card && card.querySelector('.product-block__title'); if (t) title = t.textContent.trim();
    var priceHtml = '';
    var p = card && card.querySelector('.product-price'); if (p) priceHtml = p.innerHTML;
    var imgEl = card && (card.querySelector('.product-block__image--active img') || card.querySelector('.product-block__image img') || card.querySelector('img'));
    var imgSrc = imgEl ? (imgEl.currentSrc || imgEl.src) : '';

    sheetBody.innerHTML =
      '<div class="pb-qb__head">' +
        (imgSrc ? '<div class="pb-qb__img"><img src="' + imgSrc + '" alt=""></div>' : '') +
        '<div class="pb-qb__meta"><div class="pb-qb__title">' + title + '</div>' +
        '<div class="product-price pb-qb__price">' + priceHtml + '</div></div>' +
      '</div>' +
      '<div class="pb-qb__options"><div class="pb-qb__loading"><span class="pb-qb__spinner"></span></div></div>' +
      '<button type="button" class="pb-qb__add" disabled>' + ADD_LABEL + '</button>';
    openShow();

    var prom = cache[handle] ? Promise.resolve(cache[handle])
      : fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(d){ cache[handle] = d; return d; });
    prom.then(function(prod){ renderOptions(prod); })
        .catch(function(e){ console.log(e); /* eslint-disable-line */ var o = sheetBody.querySelector('.pb-qb__options'); if (o) o.textContent = 'Impossibile caricare le opzioni.'; });
  }

  function distinctValues(prod, oi){
    var seen = {}, out = [];
    prod.variants.forEach(function(v){ var val = v.options[oi]; if (!(val in seen)){ seen[val] = 1; out.push(val); } });
    return out;
  }

  // is there an available variant with options[oi]===val, consistent with other currently-selected options
  function valueAvailable(prod, oi, val){
    return prod.variants.some(function(v){
      if (!v.available) return false;
      if (v.options[oi] !== val) return false;
      for (var j = 0; j < state.selected.length; j++){
        if (j !== oi && state.selected[j] != null && v.options[j] !== state.selected[j]) return false;
      }
      return true;
    });
  }

  function renderOptions(prod){
    state = { prod: prod, selected: [] };
    var names = prod.options.map(function(o){ return (o && o.name) ? o.name : o; }); // product.js options can be strings or {name,...}
    // auto-select options that have only one value
    names.forEach(function(_, oi){
      var vals = distinctValues(prod, oi);
      state.selected[oi] = (vals.length === 1) ? vals[0] : null;
    });
    var html = '';
    names.forEach(function(name, oi){
      var vals = distinctValues(prod, oi);
      if (vals.length === 1) return; // nothing to choose, hide single-value options
      html += '<div class="pb-qb__group" data-oi="' + oi + '"><div class="pb-qb__label">' + escapeHtml(name) + '</div><div class="pb-qb__vals">';
      vals.forEach(function(val){
        html += '<button type="button" class="pb-qb__opt" data-oi="' + oi + '" data-val="' + escapeAttr(val) + '">' + escapeHtml(val) + '</button>';
      });
      html += '</div></div>';
    });
    if (html === '') { html = ''; }
    var optBox = sheetBody.querySelector('.pb-qb__options');
    optBox.innerHTML = html;
    refresh();
  }

  function selectOption(oi, val){
    state.selected[oi] = val;
    refresh();
  }

  function refresh(){
    if (!state) return;
    var prod = state.prod;
    // update button states
    sheetBody.querySelectorAll('.pb-qb__group').forEach(function(group){
      var oi = parseInt(group.getAttribute('data-oi'), 10);
      group.querySelectorAll('.pb-qb__opt').forEach(function(btn){
        var val = btn.getAttribute('data-val');
        var avail = valueAvailable(prod, oi, val);
        btn.classList.toggle('is-selected', state.selected[oi] === val);
        btn.classList.toggle('is-unavailable', !avail);
        btn.disabled = !avail;
      });
    });
    // resolve variant + update add button
    var variant = resolveVariant();
    var addBtn = sheetBody.querySelector('.pb-qb__add');
    if (variant && variant.available){
      addBtn.disabled = false;
      addBtn.setAttribute('data-variant-id', variant.id);
      addBtn.textContent = ADD_LABEL;
    } else {
      addBtn.disabled = true;
      addBtn.removeAttribute('data-variant-id');
      addBtn.textContent = allChosen() ? 'Esaurito' : ADD_LABEL;
    }
  }

  function allChosen(){
    return state.selected.every(function(s){ return s != null; });
  }

  function resolveVariant(){
    if (!allChosen()) return null;
    return state.prod.variants.find(function(v){
      return state.selected.every(function(sel, j){ return v.options[j] === sel; });
    }) || null;
  }

  function doSheetAdd(addBtn){
    var vid = addBtn.getAttribute('data-variant-id');
    if (!vid) return;
    addBtn.disabled = true;
    addBtn.classList.add('is-loading');
    addVariant(vid).then(function(){
      addBtn.classList.remove('is-loading');
      closeSheet();
      openCart();
    }).catch(function(e){
      console.log(e); // eslint-disable-line
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
      addBtn.textContent = 'Riprova';
    });
  }

  function escapeHtml(s){ return String(s).replace(/[&<>"']/g, function(c){ return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
  function escapeAttr(s){ return escapeHtml(s); }

  /* ---- delegated trigger on every card quick-add button ---- */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.pb-quick-add');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var mode = btn.getAttribute('data-mode');
    if (mode === 'choose'){
      var card = btn.closest('product-block') || btn.closest('.product-card');
      var handle = btn.getAttribute('data-product-handle');
      if (handle) openSheet(card, handle);
    } else {
      instantAdd(btn);
    }
  });
})();
